import React from "react";
import { Link } from "react-router-dom";
import whyUsImg from "../../../assets/images/why-us/why-us.jpg";

const WhyChooseUs = () => {
  return (
    <div className="mt-[40px] md:mt-[55px] mb-[45px] md:mb-[60px]">
      <section className="mb-3 text-gray-800">
        <div className="text-center lg:text-left">
          <div className="grid md:grid-cols-2 fle items-center">
            <div
              className="mb-12 md:mb-0"
              data-aos="zoom-in"
              data-aos-duration="2000"
            >
              <div className="block rounded-xl shadow-2xl hover:shadow-xl my-transition-4 px-8 py-8 md:py-12 md:px-12 lg:-mr-14 my-style">
                <h2 className="mb-4 pb-2 text-[27.5px] md:text-[34px] font-bold opacity-80 my-transition-4">
                  Why We Are Great?
                </h2>
                <p className="text-black opacity-75 -mt-1 md:mt-0 mb-5 md:mb-6 pb-2 text-justify md:text-left">
                  We always help people to buy and sell their used mobile
                  phones. Our solutions are built to be safe, smart, and
                  convenient for our customers.
                </p>
                <div className="grid grid-cols-2 md:grid-cols-3  mb-6">
                  <div className="w-ful md:w-4/1 mb-4">
                    <p className="flex items-center justify-center lg:justify-start my-transition-7">
                      <svg
                        className="w-4 h-4 mr-2 text-gray-700"
                        role="img"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 512 512"
                      >
                        <path
                          fill="currentColor"
                          d="M504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zM227.314 387.314l184-184c6.248-6.248 6.248-16.379 0-22.627l-22.627-22.627c-6.248-6.249-16.379-6.249-22.628 0L216 308.118l-70.059-70.059c-6.248-6.248-16.379-6.248-22.628 0l-22.627 22.627c-6.248 6.248-6.248 16.379 0 22.627l104 104c6.249 6.249 16.379 6.249 22.628.001z"
                        ></path>
                      </svg>
                      Support 24/7
                    </p>
                  </div>

                  <div className="w-ful md:w-4/1 mb-4">
                    <p className="flex items-center justify-center lg:justify-start my-transition-7">
                      <svg
                        className="w-4 h-4 mr-2 text-gray-700"
                        role="img"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 512 512"
                      >
                        <path
                          fill="currentColor"
                          d="M504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zM227.314 387.314l184-184c6.248-6.248 6.248-16.379 0-22.627l-22.627-22.627c-6.248-6.249-16.379-6.249-22.628 0L216 308.118l-70.059-70.059c-6.248-6.248-16.379-6.248-22.628 0l-22.627 22.627c-6.248 6.248-6.248 16.379 0 22.627l104 104c6.249 6.249 16.379 6.249 22.628.001z"
                        ></path>
                      </svg>
                      Updates
                    </p>
                  </div>

                  <div className="w-ful md:w-4/1 mb-4">
                    <p className="flex items-center justify-center lg:justify-start my-transition-7">
                      <svg
                        className="w-4 h-4 mr-2 text-gray-700"
                        role="img"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 512 512"
                      >
                        <path
                          fill="currentColor"
                          d="M504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zM227.314 387.314l184-184c6.248-6.248 6.248-16.379 0-22.627l-22.627-22.627c-6.248-6.249-16.379-6.249-22.628 0L216 308.118l-70.059-70.059c-6.248-6.248-16.379-6.248-22.628 0l-22.627 22.627c-6.248 6.248-6.248 16.379 0 22.627l104 104c6.249 6.249 16.379 6.249 22.628.001z"
                        ></path>
                      </svg>
                      Responsive
                    </p>
                  </div>

                  <div className="w-ful md:w-4/1 mb-4">
                    <p className="flex items-center justify-center lg:justify-start my-transition-7">
                      <svg
                        className="w-4 h-4 mr-2 text-gray-700"
                        role="img"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 512 512"
                      >
                        <path
                          fill="currentColor"
                          d="M504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zM227.314 387.314l184-184c6.248-6.248 6.248-16.379 0-22.627l-22.627-22.627c-6.248-6.249-16.379-6.249-22.628 0L216 308.118l-70.059-70.059c-6.248-6.248-16.379-6.248-22.628 0l-22.627 22.627c-6.248 6.248-6.248 16.379 0 22.627l104 104c6.249 6.249 16.379 6.249 22.628.001z"
                        ></path>
                      </svg>
                      Easily Use
                    </p>
                  </div>

                  <div className="w-ful md:w-4/1 mb-4">
                    <p className="flex items-center justify-center lg:justify-start my-transition-7">
                      <svg
                        className="w-4 h-4 mr-2 text-gray-700"
                        role="img"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 512 512"
                      >
                        <path
                          fill="currentColor"
                          d="M504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zM227.314 387.314l184-184c6.248-6.248 6.248-16.379 0-22.627l-22.627-22.627c-6.248-6.249-16.379-6.249-22.628 0L216 308.118l-70.059-70.059c-6.248-6.248-16.379-6.248-22.628 0l-22.627 22.627c-6.248 6.248-6.248 16.379 0 22.627l104 104c6.249 6.249 16.379 6.249 22.628.001z"
                        ></path>
                      </svg>
                      Payments
                    </p>
                  </div>

                  <div className="w-ful md:w-4/1 mb-4">
                    <p className="flex items-center justify-center lg:justify-start my-transition-7">
                      <svg
                        className="w-4 h-4 mr-2 text-gray-700"
                        role="img"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 512 512"
                      >
                        <path
                          fill="currentColor"
                          d="M504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zM227.314 387.314l184-184c6.248-6.248 6.248-16.379 0-22.627l-22.627-22.627c-6.248-6.249-16.379-6.249-22.628 0L216 308.118l-70.059-70.059c-6.248-6.248-16.379-6.248-22.628 0l-22.627 22.627c-6.248 6.248-6.248 16.379 0 22.627l104 104c6.249 6.249 16.379 6.249 22.628.001z"
                        ></path>
                      </svg>
                      Community
                    </p>
                  </div>
                </div>
                <Link to="/home">
                  <button
                    type="button"
                    className="-mt-12 md:mt-0 inline-block px-5 py-3 bg-cyan-600 text-white font-medium text-sm uppercase rounded-lg shadow-lg hover:bg-cyan-700 hover:shadow-xl my-transition-9"
                    data-mdb-ripple="true"
                    data-mdb-ripple-color="light"
                  >
                    Get Started
                  </button>
                </Link>
              </div>
            </div>

            <div data-aos="fade-up" data-aos-duration="2000">
              <img
                src={whyUsImg}
                className="w-full object-cover md:w-full rounded-lg shadow-lg my-transition-4"
                title="Why We Are Great To You?"
                alt="why-we-great"
              />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default WhyChooseUs;
